import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import { ApiService } from "../../../../services/ApiService";
import { ConfirmTemplate } from "../../../../components/confirm";
import { useAlert } from "react-alert";
import { muchAndLearnMngtThunk } from "../../../../store/actions/trainingmanagement/training.thunk";
import { employeeMngtThunk } from "../../../../store/actions/employeemanagement/employee.thunk";
import useModal from "../../../../utils/useModal";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import EditTheme from "./edit_theme";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

export const ViewAllTheme = () => {
  const alert = useAlert();

  const [theme, setTheme] = useState({});

  const { themeOfTheWeek } = useSelector((state) => state.trainingMngt);
  const { employees } = useSelector((state) => state.employeeMngt);
  const dispatch = useDispatch();
  const { modalIsOpen, openModal, closeModal } = useModal();

  console.log("theme", themeOfTheWeek);
  console.log("theme", theme);
  console.log("user", employees);

  const getAllThemOfTheWeek = useCallback(async () => {
    await dispatch(muchAndLearnMngtThunk.getAllThemeOfTheWeek());
    await dispatch(employeeMngtThunk.getEmployeesDetails());
  }, [dispatch]);

  useEffect(() => {
    getAllThemOfTheWeek();
  }, []);

  const deleteRequest = (ids) => {
    const request = async () => {
      const id = {
        id: ids,
      };
      const res = await ApiService.post(`delete-theme-week/${id}`);
      if (res.data.type === false) {
        alert.error(res.data.msg);
      } else if (res.data.type === true) {
        alert.success(res.data.msg);
        getAllThemOfTheWeek();
      }
    };
    ConfirmTemplate(
      {
        title: "Delete Theme Of The Week",
        message: "Are You Sure You Want To Delete This Theme Of The Week",
      },
      request
    );
  };

  return (
    <React.Fragment>
      <TrainingNavbar />
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="add cases modal"
      >
        <EditTheme
          closeModal={closeModal}
          alert={alert}
          users={employees}
          getThemes={getAllThemOfTheWeek}
          theme={theme}
        />
      </Modal>
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="table-wrapper table-responsive">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-xs-12"
                    id="munch_learn_content_wrapper"
                  >
                    <div class="">
                      <table
                        id="munch_learn_view"
                        class="table table-striped table-bordered learn-table"
                      >
                        <thead>
                          <tr>
                            <th class="th-sm">
                              <b> NO </b>
                            </th>
                            <th class="th-sm" style={{ width: "250px" }}>
                              <b> NAME </b>
                            </th>
                            <th class="th-sm" style={{ width: "200px" }}>
                              <b> DUE DATE </b>
                            </th>
                            <th class="th-sm" style={{ width: "270px" }}>
                              <b> THEME </b>
                            </th>
                            <th class="th-sm" style={{ width: "200px" }}>
                              <b> EMAIL </b>
                            </th>
                            <th class="th-sm notexport">
                              <b>ACTION</b>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {themeOfTheWeek.map((theme, i) => (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>{theme.name}</td>
                              <td>{theme.due_date}</td>
                              <td>{theme.theme}</td>
                              <td> {theme.email}</td>
                              <td>
                                <div class="dropdown">
                                  <a
                                    href="#"
                                    class="dropdown-toggle card-drop arrow-none"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <h3 class="m-0 text-muted">
                                      <i class="fa fa-ellipsis-v"></i>
                                    </h3>
                                  </a>
                                  <div
                                    class="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="btnGroupDrop1"
                                  >
                                    <a
                                      className="edit_theme"
                                      id="edit_theme"
                                      onClick={() => {
                                        const value = {
                                          id: theme.id,
                                          name: theme.name,
                                          due_date: theme.due_date,
                                          email: theme.email,
                                          theme: theme.theme,
                                        };
                                        setTheme(value);
                                        openModal();
                                      }}
                                    >
                                      Edit
                                    </a>

                                    {/* <a
                                      class="dropdown-item"
                                      onClick={() => {
                                        editTheme(theme.id);
                                      }}
                                    >
                                      Edit
                                    </a> */}
                                    {/* <Link
                                      to={`/dashboard/training/edit-theme/${btoa(
                                        theme.id
                                      )}`}
                                      className="dropdown-item"
                                    >
                                      Edit
                                    </Link> */}
                                    <a
                                      class="dropdown-item"
                                      onClick={() => {
                                        deleteRequest(theme.id);
                                      }}
                                    >
                                      Delete
                                    </a>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/themeoftheweek/view_all.js